<template>
  <v-tooltip bottom>
    <template #activator="{ on, attrs }">
      <button
        v-bind="attrs"
        class="ac2-wms-btn"
        :class="[
          synced ? 'ac2-wms-btn--synced' : 'ac2-wms-btn--unsynced',
          { 'ac2-wms-btn--readonly': readonly }
        ]"
        :disabled="loading"
        v-on="on"
        @click="onClick()">
        <v-progress-circular
          v-if="loading"
          indeterminate
          size="12"
          width="2" />
        <span v-else>WMS</span>
      </button>
    </template>
    <div v-if="syncedAt">
      WMS last sync date {{ syncedAt | dateTimeUserFormat() }}
    </div>
    <div v-else>
      WMS not sync yet
    </div>
    <div v-if="readonly">
      {{ readonlyText }}
    </div>
    <div v-else>
      (click to sync again)
    </div>
  </v-tooltip>
</template>

<script>
// ปุ่มแสดงสถานะ sync AC2 WMS (เขียว = sync แล้ว, แดง = ยังไม่ sync) ทรงเดียวกับปุ่ม print ในหน้า DN/WN
export default {
  props: {
    synced: {
      type: Boolean,
      default: false
    },
    syncedAt: {
      type: [String, Date],
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    // แสดงสถานะอย่างเดียว กด sync ไม่ได้ (เช่น sub-order completed แล้ว)
    readonly: {
      type: Boolean,
      default: false
    },
    readonlyText: {
      type: String,
      default: '(sync is not available)'
    }
  },
  methods: {
    onClick () {
      if (this.readonly) {
        return
      }

      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.ac2-wms-btn {
  height: 32px;
  min-width: 44px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dce1e6;
  background: #fff;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  cursor: pointer;

  &--synced {
    border-color: #b6e0c6;
    background: #e8f3ec;
    color: #1f8a50;

    &:hover {
      background: #daeee1;
      border-color: #8fd0a8;
    }
  }

  &--unsynced {
    border-color: #f2c4c4;
    background: #fdf0f0;
    color: #c53030;

    &:hover {
      background: #fbe3e3;
      border-color: #e8a3a3;
    }
  }

  &--readonly {
    cursor: default;

    &.ac2-wms-btn--synced:hover {
      background: #e8f3ec;
      border-color: #b6e0c6;
    }

    &.ac2-wms-btn--unsynced:hover {
      background: #fdf0f0;
      border-color: #f2c4c4;
    }
  }

  &:disabled {
    border-color: #e4e8ec;
    background: #f4f6f8;
    color: #9aa5b1;
    cursor: not-allowed;
  }
}
</style>
